// src/context/ServicesContext.js
import { createContext } from 'react';

export const ServicesContext = createContext();
